import main from './main.vue'
const commonCarrierSelect = {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
export default commonCarrierSelect